import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useGetServiceOrderLinesCS } from "../hooks/ServiceOrder/useGetServiceOrderLinesCS";

interface IServiceOrderLinesContainerProps {
    serviceOrderID: number;
}

export default function ServiceOrderLinesContainer(
    props: Readonly<IServiceOrderLinesContainerProps>,
) {
    const { data: lines, isLoading } = useGetServiceOrderLinesCS(
        props.serviceOrderID,
    );

    return (
        <Table className="foTable">
            <TableHead>
                <TableRow>
                    <TableCell>Line</TableCell>
                    <TableCell>Item</TableCell>
                    <TableCell>Qty</TableCell>
                    <TableCell>Price</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {isLoading && (
                    <TableRow>
                        <TableCell colSpan={4}>Loading</TableCell>
                    </TableRow>
                )}
                {!isLoading &&
                    lines?.map((line) => (
                        <TableRow key={line.lineNumber}>
                            <TableCell>{line.lineNumber}</TableCell>
                            <TableCell>{line.itemNumber}</TableCell>
                            <TableCell>
                                {line.orderedSalesQuantity} {line.salesUnitSymbol}
                            </TableCell>
                            <TableCell>
                                {line.currencyCode} {line.salesPrice.toFixed(2)}
                            </TableCell>
                        </TableRow>
                    ))}
            </TableBody>
        </Table>
    );
}
